import React from 'react';
import styled from 'styled-components';
import { isEmpty } from 'lodash';

import NoFlightsBlock from './components/NoFlightsBlock';
import NearestOffersInfoBlock from './components/NearestOffersInfoBlock';
import NearestDeparturesBlock from './components/NearestDeparturesBlock';

import { NEAREST_OFFERS_CONTAINER_TEST_ID } from './constants';
import type { Departure, INearestOffers } from './types';

export const NearestOffers = (props: INearestOffers) => {
  const {
    nearestDeparturesData,
    nearestDatesData,
    isMobile,
    className = '',
  } = props;

  const { initial, result } = nearestDeparturesData || nearestDatesData || {};
  if (!initial || !result) return null;

  const isDeparture = 'departure' in result;
  const isDestinations = 'destinations' in result;
  const isDate = 'date' in result;

  const { nearestDepartures } = nearestDeparturesData ?? {};
  const departure = (
    isDeparture ? result.departure : initial.departure
  ) as Pick<Departure, 'nameForm2'>;

  const departureChanged = isDeparture && !isEmpty(result.departure);
  const destinationChanged = isDestinations && !isEmpty(result.destinations);
  const dateChanged = isDate && !isEmpty(result.date);

  const isNearestDeparturesBlock =
    !!nearestDepartures && !isEmpty(nearestDepartures);

  return (
    <Wrapper
      className={className}
      data-testid={NEAREST_OFFERS_CONTAINER_TEST_ID}
    >
      <ResultDepartureBlock isMobile={isMobile}>
        <NoFlightsBlock
          initial={initial}
          destinationChanged={destinationChanged}
          departureChanged={departureChanged}
          dateChanged={dateChanged}
        />
        <br />
        <NearestOffersInfoBlock
          result={result}
          departure={departure}
          departureChanged={departureChanged}
          destinationChanged={destinationChanged}
          dateChanged={dateChanged}
          isMobile={isMobile}
        />
      </ResultDepartureBlock>

      {isNearestDeparturesBlock && (
        <NearestDeparturesBlock
          departures={nearestDepartures}
          isMobile={isMobile}
        />
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  box-shadow: 0px 1px 2px rgba(210, 208, 197, 0.9),
    0px 10px 15px rgba(216, 214, 204, 0.9);
  border-radius: 4px;
  background: #ffffff;
`;

const ResultDepartureBlock = styled.div<{ isMobile: boolean }>`
  padding: 9px 24px 9px 16px;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;

  color: ${({ theme }) => theme.colors.blackLight};

  ${({ isMobile }) =>
    isMobile &&
    `
    padding: 7px 8px 9px;
    font-size: 18px;
    line-height: 22px;
  `}
`;
